__webpack_require__.p = "/reports-echarts-ng-tooltips/referrals-hub/";